import React, { useState } from 'react';
import InternalSidebar from '../../components/InternalSidebar';
import InternalTopMenu from '../../components/InternalTopMenu';
import EmailVerificationBanner from '../../components/EmailVerificationBanner';
import { useAuth } from '../../contexts/AuthContext';

const OPTIONS = [
  {
    id: 'personal',
    label: 'Dados Pessoais',
    description: 'Atualize nome, apelido e dados básicos da sua conta.',
    href: '/account/edit',
    icon: 'bi-person',
  },
  {
    id: 'password',
    label: 'Alterar Senha',
    description: 'Defina uma nova senha com letras maiúsculas e caracteres especiais.',
    href: '/security/changepassword',
    icon: 'bi-shield-lock',
  },
  {
    id: 'pix',
    label: 'Chaves PIX',
    description: 'Cadastre, edite ou remova suas chaves Pix para transferências.',
    href: '/bank/pix',
    icon: 'bi-key',
  },
  {
    id: 'level',
    label: 'Nível da Conta',
    description: 'Confira os requisitos e benefícios dos níveis de conta.',
    href: '/account/level',
    icon: 'bi-stars',
  },
  {
    id: 'security',
    label: 'Segurança',
    description: 'Ative a verificação em duas etapas com um app autenticador.',
    href: '/account/security',
    icon: 'bi-shield-check',
  },
];

const AccountHome = () => {
  const { logout } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  return (
    <div className="min-h-screen bg-[#f7f7f7] text-slate-700">
      <div className="min-h-screen flex flex-col lg:flex-row">
        <div className="lg:hidden">
          <div className="flex items-center justify-between px-6 py-4 bg-white shadow-sm">
            <button
              type="button"
              className="text-2xl text-slate-700"
              onClick={toggleSidebar}
              aria-label="Abrir menu"
            >
              <i className="bi-list"></i>
            </button>
            <img src="/img/branded/logob.png" alt="Stackfy" className="h-8" />
            <div className="w-7" />
          </div>
        </div>

        <InternalSidebar active="account" open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

        {sidebarOpen && (
          <button
            type="button"
            className="fixed inset-0 bg-slate-900/50 z-40 lg:hidden"
            onClick={() => setSidebarOpen(false)}
            aria-label="Fechar menu"
          ></button>
        )}

        <main className="flex-1 px-6 py-8 lg:px-10 lg:py-12">
          <EmailVerificationBanner />
          <header className="mb-8 flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
            <div>
              <h1 className="text-2xl font-semibold text-slate-900">Minha Conta</h1>
              <p className="text-sm text-slate-500">Gerencie seus dados pessoais, segurança e limites.</p>
            </div>
            <InternalTopMenu onLogout={logout} />
          </header>

          <section className="grid gap-4 md:grid-cols-2">
            {OPTIONS.map((option) => (
              <a
                key={option.id}
                href={option.href}
                className="rounded-3xl border border-slate-200 bg-white px-6 py-6 shadow-sm transition-transform hover:-translate-y-1 hover:shadow-md"
                onClick={() => setSidebarOpen(false)}
              >
                <div className="flex items-center gap-3 text-slate-900">
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-slate-100 text-lg text-slate-600">
                    <i className={option.icon}></i>
                  </div>
                  <h2 className="text-lg font-semibold">{option.label}</h2>
                </div>
                <p className="mt-3 text-xs text-slate-500">{option.description}</p>
                <div className="mt-4 inline-flex items-center gap-2 text-xs font-semibold text-tBlue">
                  Acessar <i className="bi-arrow-right-short text-lg"></i>
                </div>
              </a>
            ))}
          </section>
        </main>
      </div>
    </div>
  );
};

export default AccountHome;

